module.exports = __webpack_public_path__ + "static/media/LeftArrow.794db949.svg";